//ESTADOS
export const ESTADOS_MEXICO = [
    { id: 1, name: "Aguascalientes" },
    { id: 2, name: "Baja California" },
    { id: 3, name: "Baja California Sur" },
    { id: 4, name: "Campeche" },
    { id: 5, name: "Coahuila de Zaragoza" },
    { id: 6, name: "Colima" },
    { id: 7, name: "Chiapas" },
    { id: 8, name: "Chihuahua" },
    { id: 9, name: "Ciudad de México" },
    { id: 10, name: "Durango" },
    { id: 11, name: "Guanajuato" },
    { id: 12, name: "Guerrero" },
    { id: 13, name: "Hidalgo" },
    { id: 14, name: "Jalisco" },
    { id: 15, name: "Estado de México" },
    { id: 16, name: "Michoacán de Ocampo" },
    { id: 17, name: "Morelos" },
    { id: 18, name: "Nayarit" },
    { id: 19, name: "Nuevo León" },
    { id: 20, name: "Oaxaca" },
    { id: 21, name: "Puebla" },
    { id: 22, name: "Querétaro" },
    { id: 23, name: "Quintana Roo" },
    { id: 24, name: "San Luis Potosí" },
    { id: 25, name: "Sinaloa" },
    { id: 26, name: "Sonora" },
    { id: 27, name: "Tabasco" },
    { id: 28, name: "Tamaulipas" },
    { id: 29, name: "Tlaxcala" },
    { id: 30, name: "Veracruz de Ignacio de la Llave" },
    { id: 31, name: "Yucatán" },
    { id: 32, name: "Zacatecas" },
];

export const getEstadoNombre = (id) => {
    const estado = ESTADOS_MEXICO.find(e => e.id === id);
    return estado ? estado.name : "Desconocido";
};

//STATUS EMISIONES
export const STATUS_EMISION = [
    { id: 0, name: "Nueva" },
    { id: 1, name: "Emitida Pendiente de Pago" },
    { id: 2, name: "Pagada Parcial" },
    { id: 3, name: "Pagada Total" },
    { id: 4, name: "Renovada" },
    { id: 5, name: "Finalizada" },
    { id: 6, name: "Cancelada" },
    { id: 7, name: "Duplicada" },
    { id: 8, name: "Emitido el certificado" },
];

export const getStatusEmisionNombre = (id) => {
    const status = STATUS_EMISION.find(s => s.id === id);
    return status ? status.name : "Desconocido";
};

//FORMA DE PAGO EMISIONES
export const FORMA_PAGO_EMISION = [
    { id: 1, name: "Tarjeta de Crédito" },
    { id: 2, name: "Tarjeta de Débito" },
    { id: 3, name: "Depósito en banco" },
    { id: 4, name: "Transferencia" },
    { id: 5, name: "Cheque" },
    { id: 6, name: "Efectivo" },
    { id: 7, name: "Domiciliación" },
    { id: 8, name: "Cargo único" },
];

export const getFormaPagoNombre = (id) => {
    const forma = FORMA_PAGO_EMISION.find(f => f.id === id);
    return forma ? forma.name : "Desconocida";

};